import { Collection } from 'modules/core/lib/mobx-rest'

import TemplateWeek from 'modules/shift_management/store/api/models/TemplateWeek'

class TemplateWeeks extends Collection<TemplateWeek> {
  get cacheKey(): string {
    return 'templateWeeks'
  }

  model() {
    return TemplateWeek
  }

  get active(): TemplateWeek[] {
    return this.filter((t) => t.isActive)
  }
}

const singleton: TemplateWeeks = new TemplateWeeks()

export default singleton
